import { Swiper, SwiperOptions, Navigation, Pagination, Autoplay, A11y } from "swiper";

export class Carousel {
	constructor() {
		Carousel.initCarousels();
	}

	static initCarousels() {
		// @ts-ignore
		Carousel.createCarousel('.hero-slider .swiper-container', {
			// Optional parameters
			direction: 'horizontal',
			loop: false,			
			a11y: {
				enabled: true				
			},
			autoplay: {
				delay: 10000,
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true, 
				
			},
			on: {
				init: function() {					
					if (this.slides.length > 1) {
						this.loop = true;							
					}
				},
				touchStart: (e) => {
					this.toggleSlideMove(true, e.el);
				},
				touchEnd: (e) => {
					this.toggleSlideMove(false, e.el);
				},
				slideChangeTransitionStart: (e) => this.toggleSlideMove(true, e.el),
				slideChangeTransitionEnd: (e) => this.toggleSlideMove(false, e.el),
			}
		});
		Carousel.createCarousel('.tile-navigation-widget .swiper-container', {
			loop: true,
			freeMode: true,
			spaceBetween: 0,
			grabCursor: true,
			slidesPerView: "auto",
			freeModeMomentum: true,
			a11y: {
				enabled: true
			},
			navigation: {
				nextEl: ".tile-navigation-next",
				prevEl: ".tile-navigation-previous",
			}
		});
		Carousel.createCarousel('.background-card-slider-lg .swiper-container',
			{
				direction: 'horizontal',
				slidesPerView: 'auto',
				loop: false,
				spaceBetween: 0,
				a11y: {
					enabled: true
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				breakpoints: {
					640: {
						spaceBetween: 20
					},
					750: {
						spaceBetween: 25
					},
				}
			});
		Carousel.createCarousel('.background-card-slider-sm .swiper-container',
			{
				direction: 'horizontal',
				slidesPerView: "auto",
				loop: false,				
				spaceBetween: 18,				
				a11y: {
					enabled: true
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				breakpoints: {
					1240 : {
						slidesPerView: 3
					}
				}
			});
		
		
		Carousel.createCarousel('.card-slider .swiper-container',
			{
				// Optional parameters
				direction: 'horizontal',
				slidesPerView: 'auto',
				loop: false,
				spaceBetween: 30,
				centeredSlides: false,
				a11y: {
					enabled: true
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				}
			});
		Carousel.createCarousel('.content-slider-handler .swiper-container',
			{
				direction: 'horizontal',
				slidesPerView: 1,
				loop: true,
				spaceBetween: 0,
				a11y: {
					enabled: true
				},
				pagination: {
					el: '.content-slider .swiper-pagination',
					type: 'bullets',
					clickable: true
				},
				navigation: {
					nextEl: ".content-slider .swiper-button-next",
					prevEl: ".content-slider .swiper-button-prev",
				}
			});
		Carousel.createCarousel('.two-column-slider .swiper-container',
			{
				direction: 'horizontal',
				slidesPerView: 1,
				loop:  true,
				spaceBetween: 0,
				watchOverflow: true,
				a11y: {
					enabled: true
				},
				pagination: {
					el: '.two-column-slider .swiper-pagination',
					type: 'bullets',
					clickable: true
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				}, 
				on: {
					init: () => {
						const sliderRealSlides = document.querySelectorAll('.two-column-slider .swiper-slide:not(.swiper-slide-duplicate)');						
						const sliderArrows = document.querySelector('.two-column-slider .arrows') as HTMLElement;
						if (sliderRealSlides.length <= 1) {
							sliderArrows.style.display = 'none';
						} else {
							sliderArrows.style.display = 'block';
						}
					}
				}
			});
		Carousel.createCarousel('.bottom-content-slider .swiper-container',
			{				
				direction: 'horizontal',
				slidesPerView: 1,
				loop: true,
				spaceBetween: 0,
				a11y: {
					enabled: true
				},
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					clickable: true
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				on: {
					slideChangeTransitionStart: (e) => {
						
						const wrapper = e.el.closest('.background-carousel-wrapper') as HTMLElement;
						const containerBg = wrapper.querySelector('.container-bg') as HTMLElement;
						containerBg.classList.add('transitioning');
						
					},
					slideChangeTransitionEnd: (e) => {
						const bgImage = (e.el.querySelector('.swiper-slide-active') as HTMLElement).dataset.bgimage;
						const containerBg = e.el.closest('.background-carousel-wrapper').querySelector('.container-bg') as HTMLElement;
						containerBg.classList.remove('transitioning');
						containerBg.style.backgroundImage = `url(${bgImage}`;
					},
				}

			});
		Carousel.createCarousel('.expanding-circle-slider .swiper-container',
			{
				direction: 'horizontal',
				slidesPerView: 3,
				loop: true,
				spaceBetween: -150,
				centeredSlides: true,
				a11y: {
					enabled: true
				},
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					clickable: true
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},			
				breakpoints: {
					1: {
						slidesPerView: 1
					},
					500: {
						slidesPerView: 2
					},
					768: {
						slidesPerView: 3
					},
				}
			});
		Carousel.createCarousel('.expanding-square-slider .swiper-container',
			{
				slidesPerView: "auto",
				direction: 'horizontal',				
				loop: false,
				spaceBetween:-50,				
				centeredSlides: true,
				initialSlide: 2,
				resizeObserver: true,
				a11y: {
					enabled: true
				},
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					clickable: true
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				breakpoints: {
					1: {
						slidesPerView: 1
					},
					950: {
						slidesPerView: "auto"
					}
				},
				on: {
					slideChangeTransitionEnd: function (e) {
						//e.update();
					}
				}
				
				
			});

		Carousel.createCarousel('.testimonial-slider .swiper-container',
			{
				direction: 'horizontal',
				slidesPerView: 2,
				loop: true,
				spaceBetween: 0,
				a11y: {
					enabled: true
				},
				pagination: {
					el: '.testimonial-slider .swiper-pagination',
					type: 'bullets',
					clickable: true
				},
				navigation: {
					nextEl: ".testimonial-slider .swiper-button-next",
					prevEl: ".testimonial-slider .swiper-button-prev",
				},			
				breakpoints: {
					1: {
						slidesPerView: 1
					},
					768: {
						slidesPerView: 2
					},
				}
			});
	}

	static createCarousel(selector: string, options: SwiperOptions): void {
		const swiperContainer = document.querySelector(selector) as HTMLElement;
		
		const autoRotation = swiperContainer?.dataset.autorotate;
		
		if (autoRotation && autoRotation === 'True') {
			options.autoplay = true;
		}
		
		if (!swiperContainer) return;
		Swiper.use([Navigation, Pagination, Autoplay, A11y]);

		new Swiper(swiperContainer, options);
	}

	static updateRevealSize(carousel: HTMLElement) {
		const activeSlide = document.querySelector('.swiper-slide-active') as HTMLElement;
		const revealSize = activeSlide.dataset.revealsize;
		const prefix = "reveal-size-";
		const classes = carousel.className.split(" ").filter(c => !c.startsWith(prefix));
		carousel.className = classes.join(" ").trim();
		carousel.classList.add(prefix + revealSize);
	}

	static toggleSlideMove(isMoving: boolean, carouselContainer: HTMLElement) {
		const carousel = carouselContainer.closest('.carousel') as HTMLElement;
		this.updateRevealSize(carousel);
		if (isMoving) {
			carousel.classList.add('slide-touching');
		} else {
			carousel.classList.remove('slide-touching');
		}
	}
}